import type { Theme } from "@clerk/types";
import styles from "./ClerkTheme.module.scss";

const clerkTheme: Theme = {
  elements: {
    main: styles.main,
    logoBox: styles.logoBox,
    header: styles.header,
    socialButtonsProviderIcon: styles.socialButtonsProviderIcon,
    formFieldInputShowPasswordIcon: styles.formFieldInputShowPasswordIcon,
    // socialButtonsBlockButtonArrow: styles.socialButtonsBlockButtonArrow,
    navbar: styles.navbar,
    card: styles.card,
    cardBox: styles.cardBox,
    dividerRow: styles.dividerRow,
    formButtonPrimary: styles.formButtonPrimary,
    formButtonReset: styles.formButtonReset,
    formFieldLabel: styles.formFieldLabel,
    formFieldRadioLabel: styles.formFieldRadioLabel,
    formFieldInput: styles.formFieldInput,
    formFieldErrorText: styles.formFieldErrorText,
    formFieldInfoText: styles.formFieldInfoText,
    formFieldInputShowPasswordButton: styles.formFieldInputShowPasswordButton,
    footer: styles.footer,
    footerActionText: styles.footerActionText,
    footerActionLink: styles.footerActionLink,
    socialButtonsBlockButton: styles.socialButtonsBlockButton,
    socialButtonsBlockButtonText: styles.socialButtonsBlockButtonText,
    scrollBox: styles.scrollBox,
    pageScrollBox: styles.pageScrollBox,
    rootBox: styles.rootBox,
    accordionTriggerButton: styles.accordionTriggerButton,
    profilePage: styles.profilePage,
    profileSection: styles.profileSection,
    profileSectionHeader: styles.profileSectionHeader,
    profileSectionItem: styles.profileSectionItem,
    profileSectionItemList: styles.profileSectionItemList,
    profileSectionTitle: styles.profileSectionTitle,
    profileSectionTitleText: styles.profileSectionTitleText,
    profileSectionContent: styles.profileSectionContent,
    profileSectionPrimaryButton: styles.profileSectionPrimaryButton,
    profileSectionPrimaryButton__connectedAccounts:
      styles.profileSectionPrimaryButtonConnectedAccounts,
    profileSection__activeDevices: styles.profileSectionActiveDevices,
    profileSection__danger: styles.profileSectionDanger,
    actionCard: styles.actionCard,
    userPreviewMainIdentifier: styles.userPreviewMainIdentifier,
    avatarBox: styles.avatarBox,
    badge: styles.badge,
    buttonArrowIcon: styles.buttonArrowIcon,
    menuItem: styles.menuItem,
    menuButtonEllipsis: styles.menuButtonEllipsis,
    checkbox: styles.checkbox,
    providerIcon: styles.providerIcon,
  },
  layout: {
    socialButtonsPlacement: "bottom",
  },
  variables: {
    fontSize: "16px",
    spacingUnit: "14px",
  },
};

export default clerkTheme;
